const UNITS = [
	{ value: 1e9, suffix: 'b' },
	{ value: 1e6, suffix: 'm' },
	{ value: 1e3, suffix: 'k' },
]

export function formatCompactNumber(value: number | null | undefined): string {
	if (value === null || value === undefined || Number.isNaN(value)) return 'N/A'
	const abs = Math.abs(value)
	if (abs < 1000) return `${value}`
	const sign = value < 0 ? '-' : ''
	for (let i = 0; i < UNITS.length; i++) {
		const hundredths = Math.floor((abs * 100) / UNITS[i].value)
		if (hundredths >= 100) {
			return `${sign}${(hundredths / 100).toFixed(2)}${UNITS[i].suffix}`
		}
	}
	return `${value}`
}

export function formatCompactDifferential(value: number | null | undefined): string {
	const diff = value ?? 0
	return `${diff < 0 ? '' : '+'}${formatCompactNumber(diff)}`
}

export function formatPercentage(value: number): string {
	return `${value.toFixed(1)}%`
}

export function formatPercentageDifferential(value: number): string {
	const rounded = Number(value.toFixed(1))
	return `${rounded < 0 ? '' : '+'}${formatPercentage(rounded === 0 ? 0 : rounded)}`
}
